import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import React, { useEffect, useState } from 'react';
import { db } from '../../data/db/db';
import { useTranslation } from 'react-i18next';


type AutocompleteProps = {
    value: string | null,
    onChange: (newVal: string | null) => void
    onBlur: () => void,
    withPos?: boolean
}

const AsyncArticleAutocomplete: React.FC<AutocompleteProps> = ({ value, onChange, onBlur, withPos = false }: AutocompleteProps) => {
    const [open, setOpen] = useState<boolean>(false);
    const [articles, setArticles] = useState<string[]>([]);
    const loading = open && articles.length === 0;
    const { t } = useTranslation();

    useEffect(() => {
        let active = true;

        if (!loading) {
            return undefined;
        }

        (async () => {
            const articlesFromDB = await db.articles
                .orderBy("ident")
                .uniqueKeys();

            if (active) {
                if (withPos) {
                    const articlesWithPos = await db.articles
                        .orderBy("[ident+pos]")
                        .keys();

                    articlesWithPos.forEach(article => {
                        /* @ts-ignore */
                        articlesFromDB.push(article[0] + "-" + article[1])
                    })
                }
                //@ts-ignore
                setArticles([...new Set(articlesFromDB.sort())]);
            }

        })();

        return () => {
            active = false;
        };
    }, [loading, withPos]);

    useEffect(() => {
        if (!open) {
            setArticles([]);
        }
    }, [open]);

    const filterOptions = (options: string[], state: { inputValue: string; }) => {
        let newOptions: string[] = []
        options.forEach((element: string) => {
            if (element.split(' ').join('').toLowerCase()
                .startsWith(state.inputValue.split(' ').join('').toLowerCase())) {
                newOptions.push(element);
            }
        })
        return newOptions;
    }

    return (
        <Autocomplete
            open={open}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            options={articles}
            loading={loading}
            loadingText={t("Lädt...")}
            noOptionsText={t("Keine Ergebnisse")}
            value={value}
            onBlur={onBlur}
            onChange={(event: any, newValue: string | null) => {
                onChange(newValue)
            }}
            renderInput={(params) =>
                <TextField
                    {...params}
                    label={t("Artikelnummer")}
                    variant="standard"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            }
            filterOptions={filterOptions}
        />
    )
}

export default AsyncArticleAutocomplete;


